import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './CategoryDetail.css'; 
import { FaChevronLeft } from 'react-icons/fa';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

const CategoryDetail = () => {
  const { slug } = useParams(); 
  const [products, setProducts] = useState([]);
  const [categoryInfo, setCategoryInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  const defaultHeroImg = "https://images.unsplash.com/photo-1596567111059-598920404771?q=80&w=2070&auto=format&fit=crop";

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);

    // 1. Kategori bilgilerini çek
    const qCat = query(collection(db, "categories"), where("slug", "==", slug));
    const unsubCat = onSnapshot(qCat, (snap) => {
      if (!snap.empty) {
        setCategoryInfo(snap.docs[0].data());
      }
    });

    // 2. Bu kategoriye ait ürünleri çek
    const qProd = query(
      collection(db, "products"), 
      where("cat", "==", slug),
      orderBy("createdAt", "desc")
    );
    
    const unsubProd = onSnapshot(qProd, (snap) => {
      const prodData = snap.docs.map(doc => ({
        docId: doc.id,
        ...doc.data()
      }));
      setProducts(prodData);
      
      // Ürünler (veya boş dizi) geldiği anda yüklemeyi kapat
      setLoading(false); 
    }, (error) => {
      console.error("Firestore hatası:", error);
      setLoading(false); // Hata olsa bile loader'dan kurtul
    });

    return () => {
      unsubCat();
      unsubProd();
    };
  }, [slug]);

  // Arka plan resmi: Ürün yoksa kategori resmini, o da yoksa default'u kullan.
  const heroBackground = products.length > 0 
    ? products[0].img 
    : (categoryInfo?.coverImg || defaultHeroImg);

  // --- KRİTİK DEĞİŞİKLİK BURADA ---
  // Eskiden burada 'return loader' vardı, o yüzden ekranın kalanı hiç render olmuyordu.
  // Şimdi loader'ı sadece 'category-products-container' içinde göstereceğiz.
  
  return (
    <div className="category-detail-page">
      <Navbar />
      
      {/* Hero alanı her zaman görünsün (Loading olsa bile en azından başlık gözükür) */}
      <div className="category-hero" style={{ 
        backgroundImage: `linear-gradient(rgba(18,16,14,0.6), rgba(18,16,14,0.9)), url(${heroBackground})` 
      }}>
        <div className="category-hero-content">
          <Link to="/kategoriler" className="back-link">
            <FaChevronLeft /> Kategorilere Dön
          </Link>
          <h1 className="category-main-title">
            {categoryInfo?.title || "Koleksiyon"} 
          </h1>
          <div className="title-separator"></div>
          {!loading && (
            <p className="category-count">
              {products.length > 0 ? `${products.length} Nadir Eser Listeleniyor` : "Koleksiyon Hazırlık Aşamasında"}
            </p>
          )}
        </div>
      </div>

      <div className="category-products-container">
        {loading ? (
          /* Yüklenirken gösterilecek sade yazı */
          <div className="loader-inline">Veriler Getiriliyor...</div>
        ) : products.length > 0 ? (
          <div className="products-grid">
            {products.map((product) => (
              <Link 
                to={`/urun/${product.id}`} 
                key={product.docId} 
                className={`product-card-premium ${product.size || 'small'}`}
              >
                <div className="card-image-wrapper">
                  <img src={product.img} alt={product.name} />
                  <div className="card-badge">#{product.id}</div>
                  <div className="card-overlay">
                    <span className="view-text">DETAYI GÖR</span>
                  </div>
                </div>
                <div className="card-info-premium">
                  <h3>{product.name}</h3>
                  <div className="card-footer">
                    <span className="price">{product.price}</span>
                    <div className="line"></div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          /* ÜRÜN YOKSA GÖRÜNECEK OLAN O ŞIK KUTU */
          <div className="no-results-premium">
            <div className="empty-icon">
              <div className="icon-circle"></div>
              <span>!</span>
            </div>
            <h2>Bu Kategori Henüz Hazırlanıyor</h2>
            <p>
              Tesbihçimen olarak en nadide eserleri seçiyoruz. <br />
              Bu koleksiyon çok yakında severleriyle buluşacak.
            </p>
            <Link to="/kategoriler" className="explore-other-btn">
              DİĞER KOLEKSİYONLARI KEŞFET
            </Link>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default CategoryDetail;